export default "__VITE_ASSET__9ada74e5__"